import { render, staticRenderFns } from "./NotificationMenu.vue?vue&type=template&id=7c474880"
import script from "./NotificationMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotificationMenu.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports